import * as React from "react";
import * as ReactDOM from "react-dom";
import {Cart} from "./components/cart/Cart/Cart";

export const init = (): void => {
  // This is the react root of our cart / application
  const cartElement = document.createElement("div");
  document.body.appendChild(cartElement);

  // region portals to everywhere

  // Element to render modal content in - outside of the dom to prevent css side effects
  const modalRootElement = document.createElement("div");
  modalRootElement.id = "ModalRootElement";
  document.body.appendChild(modalRootElement);

  const reactCartIcon: HTMLAnchorElement | null = document.querySelector("#CartIcon");
  if (reactCartIcon) {
    const cartIcon = document.createElement("span");
    cartIcon.id = "CartIconRoot";
    document.body.appendChild(cartIcon);
  }

  const addToCartButtonRoot = document.createElement("div");
  addToCartButtonRoot.id = "AddToCartButtonRoot";
  addToCartButtonRoot.className = "product-cart__form";
  document.body.appendChild(addToCartButtonRoot);

  const addToWishlistOrig = document.getElementsByClassName("product-cart__wishlist")[0];
  if (addToWishlistOrig) {
    const addToWishlistNew = document.createElement("div");
    addToWishlistNew.id = "AddToWishlistButtonNew";
    addToWishlistNew.className = addToWishlistOrig.className;
    document.body.appendChild(addToWishlistNew);
  }

  // endregion

  ReactDOM.render(<Cart />, cartElement);
};
